import React from 'react';
import '../less/main.less';
import DOMPurify from 'utils/sanitize';
import { ReactSVG } from 'react-svg';
import { getSafeLinkProps } from '../../../../helpers/utils/urlSecurity';

export default function template() {
  const { data, img, imgAlt, page, className, award, svg, imgBottom } = this.props;

  return (
    <div className={`hero ${!data.link ? 'no-btn' : ''} ${!data.cards ? 'no-cards' : ''} ${page ? `hero_${page}` : ''} ${className ? className : ''} ${this.context.theme || ''} ${award ? 'award' : ''}`}>
      <div className="container">
        <div className="hero__body">
          {svg ? (
            <ReactSVG src={img} className={`hero__image${imgBottom ? ' hero__image_bottom' : ''}`}/>
          ) : (
            <div className={`hero__image${imgBottom ? ' hero__image_bottom' : ''}`}>
              <img src={img} alt={imgAlt ? this.l10n(imgAlt) : ''} />
            </div>
          )}
          <div className="hero__left">
            <div className="hero__content">
              {data.logo && <ReactSVG src={data.logo} className="hero__logo"/>}
              {data.date && <div className="hero__date" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(data.date))}}></div>}
              <h1 className="hero__title" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(data.title))}}></h1>
              <div className="hero__text" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(data.text))}}></div>
              {data.link ? (
                data.link.onClick ? (
                  <button
                    className="hero__btn"
                    onClick={data.link.onClick}
                    id={`${page ? page : ''} banner-button`}
                  >
                    {this.l10n(data.link.text)}
                  </button>
                ) : data.link.href ? (
                  <a
                    className="hero__btn"
                    {...getSafeLinkProps(data.link.href)}
                    id={`${page ? page : ''} banner-button`}
                  >
                    {this.l10n(data.link.text)}
                  </a>
                ) : null
              ) : null}
            </div>
          </div>
          {data.cards && (
            <div className="hero__cards cards-hero">
              {data.cards.map((item, index) => {
                const cardContent = (
                  <>
                  {item.img && (
                      <img src={item.img} className="cards-hero__image" alt={item.alt ? this.l10n(item.alt) : ''}/>
                    )}
                    <div className="cards-hero__content">
                      <div className="cards-hero__title" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(item.title))}}></div>
                      {item.text && (
                        <div className="cards-hero__text" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(item.text))}}></div>
                      )}
                    </div>
                    {item.imgBottom && (
                      <img src={item.imgBottom} className="cards-hero__image" alt={item.altBottom ? this.l10n(item.altBottom) : ''}/>
                    )}
                  </>
                );
                return item.href ? (
                  <a
                    key={index}
                    className="cards-hero__item"
                    {...getSafeLinkProps(item.href, {target: item.target})}
                  >
                    {cardContent}
                  </a>
                ) : (
                  <div className="cards-hero__item" key={index}>
                    {cardContent}
                  </div>
                );
              })}
            </div>
          )}
          {award && (
            <a className="hero__award award-hero" href={award.link} rel="noopener noreferrer" target='_blank'>
              <img src={award.img} alt={this.l10n(award.text)} className="award-hero__image"/>
              <div className="award-hero__content">
                <div className="award-hero__title">{this.l10n(award.title)}</div>
                <div className="award-hero__text">{this.l10n(award.text)}</div>
              </div>
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
